import React, { useEffect } from "react";

import AOS from "aos";

// import Loading from "../../components/Laoding";

export default function CardVisiMisi(props) {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <div className="pt-3" data-aos="fade-right">
        <div className="cardMisi">
          <div className="card">
            <div className="card-body">
              <div className="text-center">
                <img src={props.image} alt="" width={props.width} />
              </div>
              <h4 className="card-title text-center py-2">{props.title}</h4>
              <div className="cardDescriptionVisiMisi">
                <p className="card-text">{props.description}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
